var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 50,
    viewBox: "0 0 121 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8572 23.6796C56.9021 23.6796 57.4856 23.304 57.4856 22.4997C57.4856 21.7483 56.9195 21.4207 55.8572 21.4207H54.7905V23.6796H55.8572ZM55.6919 20.4727C56.6844 20.4727 57.1066 20.0842 57.1066 19.4635C57.1066 18.773 56.6407 18.5107 55.7182 18.5107H54.7905V20.4727H55.6919ZM53.5279 17.5237H55.8051C57.2678 17.5237 58.3433 17.9737 58.3433 19.2846C58.3433 19.957 57.9777 20.6126 57.355 20.8314V20.8749C58.143 21.0537 58.722 21.6043 58.722 22.5698C58.722 23.9989 57.5551 24.6669 55.9878 24.6669H53.5279V17.5237Z",
    fill: "#A5AEBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5901 17.5232H60.8527V24.6667H59.5901V17.5232Z",
    fill: "#A5AEBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8221 23.6401C65.2544 23.6401 66.0774 22.823 66.0774 21.0666C66.0774 19.3104 65.2544 18.5499 63.8221 18.5499H63.2693V23.6401H63.8221ZM62.0066 17.5232H63.9049C66.0863 17.5232 67.3749 18.7031 67.3749 21.0666C67.3749 23.4304 66.0863 24.6667 63.9703 24.6667H62.0066V17.5232Z",
    fill: "#A5AEBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5527 18.5897H69.4977V17.5237H74.8703V18.5897H72.8153V24.6672H71.5527V18.5897Z",
    fill: "#A5AEBC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6234 17.5232H76.886V20.3939H79.764V17.5232H81.0267V24.6667H79.764V21.4992H76.886V24.6667H75.6234V17.5232Z",
    fill: "#A5AEBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1866 17.5232H83.4493V24.6667H82.1866V17.5232Z",
    fill: "#A5AEBC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1157 23.7518L84.8515 22.8825C85.361 23.3693 86.0446 23.697 86.7061 23.697C87.5073 23.697 87.9473 23.3325 87.9473 22.7753C87.9473 22.1876 87.4877 21.9998 86.8414 21.7242L85.8682 21.3004C85.1672 21.008 84.4292 20.4508 84.4292 19.4067C84.4292 18.2684 85.4305 17.3923 86.8196 17.3923C87.6511 17.3923 88.4564 17.7374 89.014 18.3032L88.3651 19.1072C87.9125 18.7206 87.4289 18.4935 86.8196 18.4935C86.1448 18.4935 85.7048 18.8104 85.7048 19.3321C85.7048 19.8938 86.2469 20.1012 86.837 20.3439L87.7968 20.7479C88.6439 21.1019 89.2358 21.6392 89.2358 22.6747C89.2358 23.8327 88.2782 24.7982 86.6802 24.7982C85.7178 24.7982 84.7908 24.4182 84.1157 23.7518Z",
    fill: "#A5AEBC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.709 31.8142C56.7713 31.8142 57.2767 31.3905 57.2767 30.5126C57.2767 29.6255 56.7236 29.3238 55.6654 29.3238H54.7905V31.8142H55.709ZM53.5279 28.3102H55.77C57.3503 28.3102 58.5216 28.8608 58.5216 30.5126C58.5216 32.1051 57.3462 32.8279 55.8136 32.8279H54.7905V35.454H53.5279V28.3102Z",
    fill: "#A5AEBC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0235 32.4773L64.7255 35.4537H63.3064L61.7744 32.6617L63.0235 32.4773ZM61.6952 31.648C62.6705 31.648 63.2018 31.2421 63.2018 30.4292C63.2018 29.6077 62.6705 29.3238 61.6952 29.3238H60.6895V31.648H61.6952ZM59.4268 28.3102H61.826C63.3064 28.3102 64.4471 28.8345 64.4471 30.4292C64.4471 31.5133 63.8786 32.1794 63.0235 32.4773C62.6673 32.6015 62.2613 32.6617 61.826 32.6617H61.7744H60.6895V35.4537H59.4268V28.3102Z",
    fill: "#A5AEBC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0418 31.8537C70.0418 30.2501 69.3192 29.2805 68.2004 29.2805C67.0812 29.2805 66.3587 30.2501 66.3587 31.8537C66.3587 33.4573 67.0812 34.484 68.2004 34.484C69.3192 34.484 70.0418 33.4573 70.0418 31.8537ZM65.061 31.8537C65.061 29.5425 66.3455 28.1793 68.2004 28.1793C70.055 28.1793 71.3392 29.5488 71.3392 31.8537C71.3392 34.1652 70.055 35.5852 68.2004 35.5852C66.3455 35.5852 65.061 34.1652 65.061 31.8537Z",
    fill: "#A5AEBC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2998 31.8142C75.3621 31.8142 75.8675 31.3905 75.8675 30.5126C75.8675 29.6255 75.3144 29.3238 74.2562 29.3238H73.3814V31.8142H74.2998ZM72.1187 28.3102H74.3608C75.9411 28.3102 77.1124 28.8608 77.1124 30.5126C77.1124 32.1051 75.937 32.8279 74.4045 32.8279H73.3814V35.454H72.1187V28.3102Z",
    fill: "#A5AEBC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0179 28.3102H82.3023V29.3762H79.2805V31.2072H81.8406V32.2732H79.2805V34.3877H82.4107V35.4537H78.0179V28.3102Z",
    fill: "#A5AEBC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0348 32.4773L88.7369 35.4537H87.3178L85.7857 32.6617L87.0348 32.4773ZM85.7065 31.648C86.6819 31.648 87.2132 31.2421 87.2132 30.4292C87.2132 29.6077 86.6819 29.3238 85.7065 29.3238H84.7008V31.648H85.7065ZM83.4382 28.3102H85.8374C87.3178 28.3102 88.4584 28.8345 88.4584 30.4292C88.4584 31.5133 87.89 32.1794 87.0348 32.4773C86.6786 32.6015 86.2727 32.6617 85.8374 32.6617H85.7857H84.7008V35.4537H83.4382V28.3102Z",
    fill: "#A5AEBC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.7092 29.3762H88.6542V28.3102H94.0269V29.3762H91.9719V35.4537H90.7092V29.3762Z",
    fill: "#A5AEBC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4261 32.7974L94.2842 28.3104H95.6338L96.4087 30.1367C96.6177 30.6676 96.818 31.1636 97.0421 31.7073H97.0858C97.3102 31.1636 97.5342 30.6676 97.7409 30.1367L98.5159 28.3104H99.8307L97.6888 32.7974V35.454H96.4261V32.7974Z",
    fill: "#A5AEBC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5326 40.712H41.9445C43.9711 40.712 45.6143 39.0634 45.6143 37.0294V16.3993C45.6143 15.1014 44.9335 13.8997 43.8226 13.2355L28.4881 4.0691C27.331 3.37736 25.8891 3.37736 24.732 4.0691L9.39787 13.2355C8.28661 13.8997 7.60614 15.1014 7.60614 16.3993V46.8644L15.4301 41.3761C16.0465 40.9438 16.7807 40.712 17.5326 40.712ZM28.0719 17.2403H25.1483V14.3061H28.0719V17.2403ZM19.3009 31.9102H16.3771V23.1082H19.3009V31.9102ZM16.3771 20.1744V17.2403H13.4535V34.844H22.2245V20.1744H16.3771ZM36.8431 31.9102H33.9193V23.1082H36.8431V31.9102ZM36.8431 17.2403V20.1744H30.9958V34.844H39.7667V17.2403H36.8431ZM25.1483 34.844H28.0719V20.1741H25.1483V34.844Z",
    fill: "#A5AEBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.e4967a250163b2a2b74098665b8bae29.svg";
export { ForwardRef as ReactComponent };